import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule, MatSelectChange } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

import {
  SOURCE_OPTIONS,
  Source,
  SourceOption
} from 'src/app/shared/model/query-body.model';

@Component({
  selector: 'app-source-selector',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslateModule
  ],
  templateUrl: './source-selector.component.html',
  styleUrls: ['./source-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SourceSelectorComponent {
  @Input() selectedSource: Source = Source.ALL;
  @Output() sourceChange = new EventEmitter<Source>();

  readonly options: SourceOption[] = SOURCE_OPTIONS;

  onSelectionChange(event: MatSelectChange): void {
    const value = event.value as Source;
    this.selectedSource = value;
    this.sourceChange.emit(value);
  }
}
